module.exports = __webpack_public_path__ + "img/maj stock.ec1522be.png";